import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-form-new-turn-schedule',
  templateUrl: './turns-form-new-turn-schedule.component.html',
  styleUrls: ['./turns-form-new-turn-schedule.component.scss']
})
export class TurnsFormNewTurnScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
